angular.module("mailings_types")

    .controller("MailingTypesListCtrl", ['LoginService', '$rootScope', '$scope','$q', 'Restangular', 'gridService', 'treeService', 'modalService', '$filter', '$state', 'logService',
        function (LoginService, $rootScope, $scope, $q, Restangular, gridService, treeService, modalService, $filter, $state, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = true // LoginService.permissionExist("MAILINGS_WRITE");

            $rootScope.title = $filter('translate')('mailings_types.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('mailings_types.title') }
            ];

            $scope.gridOptions = {
                pdfTitle: $filter('translate')('mailings_types.title'),
                exporterMenuCsv: true,
                gridMenuShowHideColumns: false,
                paginationPageSizes: [15, 30, 45],
                paginationPageSize: 15,
                // rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },

                columnDefs: [            
                    { name: 'name', displayName: $filter('translate')('general.name'), enableFiltering: true, enableHiding: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.edit'), action: 'ui-sref="mailings_types.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {

                    return Restangular.all('MailingsTypesGrid').getList(options);

                }

            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("mailings_types.edit", {id: rowEntity.id });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('mailings_types.delete'),
                    message: $filter('translate')('mailings_types.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('MailingsTypes', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('mailings_types.remove_success'));
                            $scope.gridOptions.data =
                                $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                        }, function (response) {
                            logService.error("Error with status code", response.status);
                        });
                    }
                });

            };

        }])

    ;